import { createSlice } from "@reduxjs/toolkit";

export const CommonSlice = createSlice({
  name: "auth",
  initialState: {
    selectedSession: "2025-2026",
  },
  reducers: {
    setSession: (state, { payload }) => {
      state.selectedSession = payload;
    },
  },
});
export default CommonSlice.reducer;
export const { setSession } = CommonSlice.actions;
